var gst_arr = localStorage.getItem("gst");  
if (gst_arr !== null) {
    if (gst_arr === 'true') {
        if (document.querySelectorAll('.IncGst') != null) {
          document.querySelectorAll('.IncGst').forEach(el => el.style.display = 'flex');
        }
        if (document.querySelectorAll('.ExcGst') != null) {
          document.querySelectorAll('.ExcGst').forEach(el => el.style.display = 'none');
        }
        if (document.querySelectorAll('.gst-enabler') != null) {
          document.querySelectorAll('.gst-enabler').forEach(el => el.checked = true);
        }
    } else {
        if (document.querySelectorAll('.IncGst') != null) {
          document.querySelectorAll('.IncGst').forEach(el => el.style.display = 'none');
        }
        if (document.querySelectorAll('.ExcGst') != null) {
          document.querySelectorAll('.ExcGst').forEach(el => el.style.display = 'flex');
        }
        if (document.querySelectorAll('.gst-enabler') != null) {
          document.querySelectorAll('.gst-enabler').forEach(el => el.checked = false);
        }
    }
}